// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b2765949","138":"dd8eea2f","227":"7cecd400","245":"fe2aa3cf","258":"b0f02aa5","286":"d13d1707","463":"59fd1e8a","473":"9860f10f","577":"cbff53de","621":"89154d43","647":"70420ac6","717":"4515e17d","810":"f176f1c8"}[chunkId] + ".chunk.js";
};